var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaseNotFoundImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "304px",
    height: "173px",
    viewBox: "0 0 304 173",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "33.0145266%",
    x2: "50%",
    y2: "269.074959%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684d94",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4081",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.472601,89.200683 C191.218891,89.200683 228.358698,92.4423977 228.358698,96.4353233 C228.358698,100.428196 191.218891,103.669911 145.472601,103.669911 C99.7263098,103.669911 62.5865029,100.428196 62.5865029,96.4353233 C62.5865029,92.4423977 99.7263098,89.200683 145.472601,89.200683 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-73.3%",
    y: "-839.7%",
    width: "246.6%",
    height: "1779.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 0   0 0 0 0 0  0 0 0 0.62 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.472601,96.4352969 C182.452403,96.4352969 212.475005,98.0561542 212.475005,100.052617 C212.475005,102.049053 182.452403,103.669911 145.472601,103.669911 C108.492798,103.669911 78.4701958,102.049053 78.4701958,100.052617 C78.4701958,98.0561542 108.492798,96.4352969 145.472601,96.4352969 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-46.9%",
    y: "-870.8%",
    width: "193.7%",
    height: "1841.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0  0 0 0 0.62 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 404,
    transform: "translate(-492.933466, -372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(479.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.577960, 107.789636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.163778604,0.961678507 L283.405333,0.961678507 L227.441521,97.7421856 C227.449189,97.7746043 227.452597,97.8070656 227.452597,97.8396547 C227.452597,101.057457 190.286952,103.669911 144.508835,103.669911 C98.7481844,103.669911 61.5927631,101.059416 61.565073,97.8432332 L0.163778604,0.961678507 Z",
    id: "Fill-1",
    fillOpacity: 0.51,
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C50057",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C51162",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseNotFoundImg);
export default __webpack_public_path__ + "static/media/baseNotFoundImg.927f60a90d859cc413b23ab8876f1506.svg";
export { ForwardRef as ReactComponent };